/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Allow_List_Title_2Inputs */

const en_daily_paywall_allow_list_title_2 = /** @type {(inputs: Daily_Paywall_Allow_List_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tailor Your Allow Lists for Every Moment`)
};

const ar_daily_paywall_allow_list_title_2 = /** @type {(inputs: Daily_Paywall_Allow_List_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خصّص قائمة السماح الخاصة بك لكل لحظة`)
};

const de_daily_paywall_allow_list_title_2 = /** @type {(inputs: Daily_Paywall_Allow_List_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passen Sie Ihre "Liste zulassen" für jeden Moment an`)
};

const es_daily_paywall_allow_list_title_2 = /** @type {(inputs: Daily_Paywall_Allow_List_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personaliza tus Lista de permisos para cada momento`)
};

const fr_daily_paywall_allow_list_title_2 = /** @type {(inputs: Daily_Paywall_Allow_List_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaptez vos Liste des autorisations à chaque instant`)
};

const it_daily_paywall_allow_list_title_2 = /** @type {(inputs: Daily_Paywall_Allow_List_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizza la tua Lista delle App Consentite per ogni momento`)
};

const ja_daily_paywall_allow_list_title_2 = /** @type {(inputs: Daily_Paywall_Allow_List_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あらゆるシーンに合わせて「許可リスト」をカスタマイズ`)
};

const ko_daily_paywall_allow_list_title_2 = /** @type {(inputs: Daily_Paywall_Allow_List_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 순간에 적합한 앱 허용 리스트를 맞춤 설정하세요`)
};

const pt_br_daily_paywall_allow_list_title_2 = /** @type {(inputs: Daily_Paywall_Allow_List_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalize sua Lista de permissões para cada momento`)
};

const ru_daily_paywall_allow_list_title_2 = /** @type {(inputs: Daily_Paywall_Allow_List_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройте свой Список разрешений под каждый момент`)
};

const th_daily_paywall_allow_list_title_2 = /** @type {(inputs: Daily_Paywall_Allow_List_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปรับแต่งรายการอนุญาตของคุณให้เหมาะกับทุกช่วงเวลา`)
};

const tr_daily_paywall_allow_list_title_2 = /** @type {(inputs: Daily_Paywall_Allow_List_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İzinli Listelerini Her Ana Göre Ayarla`)
};

const zh_cn_daily_paywall_allow_list_title_2 = /** @type {(inputs: Daily_Paywall_Allow_List_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`依据不同情境
打造最适合你的白名單`)
};

const zh_tw_daily_paywall_allow_list_title_2 = /** @type {(inputs: Daily_Paywall_Allow_List_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`依據不同情境
打造最適合你的允許名單`)
};

/**
* | output |
* | --- |
* | "Tailor Your Allow Lists for Every Moment" |
*
* @param {Daily_Paywall_Allow_List_Title_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_allow_list_title_2 = /** @type {((inputs?: Daily_Paywall_Allow_List_Title_2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Allow_List_Title_2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_allow_list_title_2(inputs)
	if (locale === "ar") return ar_daily_paywall_allow_list_title_2(inputs)
	if (locale === "de") return de_daily_paywall_allow_list_title_2(inputs)
	if (locale === "es") return es_daily_paywall_allow_list_title_2(inputs)
	if (locale === "fr") return fr_daily_paywall_allow_list_title_2(inputs)
	if (locale === "it") return it_daily_paywall_allow_list_title_2(inputs)
	if (locale === "ja") return ja_daily_paywall_allow_list_title_2(inputs)
	if (locale === "ko") return ko_daily_paywall_allow_list_title_2(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_allow_list_title_2(inputs)
	if (locale === "ru") return ru_daily_paywall_allow_list_title_2(inputs)
	if (locale === "th") return th_daily_paywall_allow_list_title_2(inputs)
	if (locale === "tr") return tr_daily_paywall_allow_list_title_2(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_allow_list_title_2(inputs)
	return zh_tw_daily_paywall_allow_list_title_2(inputs)
});